import { CoreFactory } from '@/bridge/factory/CoreFactory';
import styles from './styles.module.scss';
import {
  useCustomTranslation,
  useConnectionSettingsStore,
  SoloNativeRTCChannel,
} from '@amzn/work-spaces-web-client-core-lib';
import { Box, Link, SpaceBetween, Toggle } from '@cloudscape-design/components';
import { useState } from 'react';

const logger = CoreFactory.getLogger();

const NETWORK_SUPPORT_URL =
  'https://docs.aws.amazon.com/workspaces/latest/adminguide/workspaces-port-requirements.html';

const ConnectionSettings = () => {
  const { t } = useCustomTranslation();

  const useDualStackIPv6 = useConnectionSettingsStore(
    (state) => state.useDualStackIPv6
  );
  const updateUseDualStackIPv6 = useConnectionSettingsStore(
    (state) => state.updateUseDualStackIPv6
  );

  const [toggleText, setToggleText] = useState(() =>
    setInitialUseDualStackToggleText()
  );

  function setInitialUseDualStackToggleText() {
    return useDualStackIPv6
      ? t('ws-usedualstackipv6-enabled')
      : t('ws-usedualstackipv6-disabled');
  }

  function updateUseDualStackIPv6Toggle(useDualStackIPv6Toggle: boolean) {
    updateUseDualStackIPv6(useDualStackIPv6Toggle);
    logger.info(
      `UseDualStackIPv6 Setting Changed to: ${useDualStackIPv6Toggle}`
    );
    setToggleText(
      useDualStackIPv6Toggle
        ? t('ws-usedualstackipv6-enabled')
        : t('ws-usedualstackipv6-disabled')
    );
    if (SoloNativeRTCChannel.isChannelAvailable()) {
      const rtcChannel = CoreFactory.getRTCChannel();
      if (rtcChannel) {
        rtcChannel.publishSettingsChange({
          UseDualStackIPv6: useDualStackIPv6Toggle,
        });
      }
    }

    logger.updateLogUploaderConfig({
      useDualStackIpv6: useDualStackIPv6Toggle,
    });
  }

  return (
    <SpaceBetween size="m" direction="vertical">
      <Box variant="awsui-key-label">
        <p
          tabIndex={0}
          role="navigation"
          aria-live="assertive"
          aria-label={t('ws-usedualstackipv6-disclaimer')}
        >
          {t('ws-usedualstackipv6-disclaimer') + ' '}
          <Link
            href={NETWORK_SUPPORT_URL}
            target="_blank"
            rel="noreferrer"
            variant="info"
          >
            <span className={styles.learnmore}>
              {t('ws-usedualstackipv6-learnmore')}
            </span>
          </Link>
        </p>
        <div
          tabIndex={0}
          role="navigation"
          aria-live="assertive"
          aria-label={t('ws-usedualstackipv6-preference')}
        >
          {t('ws-usedualstackipv6-preference')}
        </div>
        <Toggle
          onChange={({ detail }) =>
            updateUseDualStackIPv6Toggle(detail.checked)
          }
          checked={useDualStackIPv6}
          aria-label={toggleText}
        >
          {toggleText}
        </Toggle>
      </Box>
    </SpaceBetween>
  );
};

export default ConnectionSettings;
